import { Injectable } from '@angular/core';

@Injectable()
export class ImageConstants {
  public readonly brushedMetalBannerBlue: string = 'assets/background/BrushedMetalBanner_Blue.jpg';
  public readonly regularBrushMetal: string = 'assets/background/regularBrushMetal.jpg';
  public readonly close: string = 'assets/buttons/close.jpg';
  public readonly darkerClose: string = 'assets/buttons/darkerClose.png';
  public readonly resetHardnessButtonActive: string = 'assets/buttons/Reset_Hardness_Button_Active.png';
  public readonly resetHardnessButtonInactive: string = 'assets/buttons/Reset_Hardness_Button_Inactive.png';
  public readonly sliderAdjusters: string = 'assets/knobs/sliderAdjusters.png';
  public readonly checkMark: string = 'assets/buttons/checkmark.png';
  public readonly logOut: string = 'assets/buttons/logout.png';
  public readonly reset: string = 'assets/buttons/reset.png';
  public readonly help: string = 'assets/buttons/help.png';
  public readonly machiningAdvisorWhite: string = 'assets/images/machiningadvisor_white.png';
  public readonly mapBallEndMill: string = 'assets/images/MAP_Ball_End_Mill.jpg';
  public readonly mapBallEndMillPadded: string = 'assets/images/MAP_Ball_End_Mill-padded.png';
  public readonly mapChamferMill: string = 'assets/images/MAP_Chamfer_Mill.jpg';
  public readonly mapChamferMillPadded: string = 'assets/images/MAP_Chamfer_Mill-padded.png';
  public readonly mapSquareEndMill: string = 'assets/images/MAP_Square_End_Mill.jpg';
  public readonly mapSquareEndMillPadded: string = 'assets/images/MAP_Square_End_Mill-padded.png';
  public readonly mapBullNosedPadded: string = 'assets/images/MAP_Bull_End_Mill-padded.png';
  public readonly defaultTool: string = 'assets/images/defaultTool.png';
  public readonly settings: string = 'assets/buttons/settings.png';
  public readonly sliders: string = 'assets/buttons/sliders.png';
  public readonly adocSlider: string = 'assets/knobs/adoc_slider.png';
  public readonly adocSliderDisabled: string = 'assets/knobs/adoc_slider_disabled.png';
  public readonly rdocSlider: string = 'assets/knobs/rdoc_slider.png';
  public readonly rdocSliderDisabled: string = 'assets/knobs/rdoc_slider_disabled.png';
  public readonly speedFeedDials: string = 'assets/knobs/speed-feed_dials.png';
  public readonly speedKnob: string = 'assets/knobs/speedKnob.png';
  public readonly speedKnoboffSet: string = 'assets/knobs/speedKnoboffSet.png';
  public readonly transTrack: string = 'assets/knobs/trans-track.png';
  public readonly transTrack2: string = 'assets/knobs/trans-track2.png';
  public readonly toolPathDefault: string = 'assets/toolpaths/tool_path_default.png';
  public readonly defaultParameterTool: string = 'assets/images/unavailableOperationImage.png';

  public readonly finishingLabeled: string = 'assets/toolpaths/labeled/finishing.png';
  public readonly fullSlottingLabeled: string = 'assets/toolpaths/labeled/full_slotting.png';
  public readonly LoopingToolPathLabeled: string = 'assets/toolpaths/labeled/looping_tool_path.png';
  public readonly offsetToolLabeled: string = 'assets/toolpaths/labeled/offset_tool.png';
  public readonly trochoidalLabeled: string = 'assets/toolpaths/labeled/trochoidal.png';
  public readonly trochoidalSlottingLabeled: string = 'assets/toolpaths/labeled/trochoidal_slotting.png';
  public readonly zigZagLabeled: string = 'assets/toolpaths/labeled/zig_zag.png';

  public readonly finishingUnlabeled: string = 'assets/toolpaths/unlabeled/finishing.png';
  public readonly fullSlottingUnlabeled: string = 'assets/toolpaths/unlabeled/full_slotting.png';
  public readonly LoopingToolPathUnlabeled: string = 'assets/toolpaths/unlabeled/looping_tool_path.png';
  public readonly offsetToolUnlabeled: string = 'assets/toolpaths/unlabeled/offset_tool.png';
  public readonly trochoidalUnlabeled: string = 'assets/toolpaths/unlabeled/trochoidal.png';
  public readonly trochoidalSlottingUnlabeled: string = 'assets/toolpaths/unlabeled/trochoidal_slotting.png';
  public readonly zigZagUnlabeled: string = 'assets/toolpaths/unlabeled/zig_zag.png';

  public readonly warningIcon: string = 'assets/icon/warningIcon.png';

  public readonly helicalLogo: string = 'assets/images/Helical_Logo.png';
  public readonly machiningAdvisorColor: string = 'assets/images/machiningadvisor_color.png';
  public readonly muSymbol: string = 'assets/images/mu.png';

  public readonly unavailableOperationImage: string = 'assets/images/unavailableOperationImage.png';
  public readonly unavailableOperationThumbnail: string = 'assets/images/unavailableOperationThumbnail.png';
  public readonly unavailableToolImage: string = 'assets/images/unavailableToolImage.png';

  public readonly iosShare: string = 'assets/icon/outline_ios_share.png';
  public readonly account: string = 'assets/buttons/outline_person.png';
}
